const styles = theme => ({
  root: {
    width: '100%',
  },
  content: {
    paddingLeft: 20,
    paddingRight: 20,
  },
  title: {
    fontSize: theme.constants.fontSizes.regular,
    fontWeight: 'bold',
    marginBottom: 5,
    paddingTop: 20,
  },
  text: {
    fontSize: theme.constants.fontSizes.regular,
    lineHeight: 1.71,
  },
  textArea: {
    paddingTop: 15,
    fontSize: theme.constants.fontSizes.small,
  },
  button: {
    minWidth: 140,
    marginTop: 30,
    marginRight: 10,
    marginBottom: 10,
  },
  note: {
    paddingRight: 20,
  },
  noteBold: {
    paddingRight: 20,
    fontWeight: 'bold',
  },
  buttonContainer: {
    paddingBottom: 10,
  },
  labelArea: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 30,
  },
  label: {
    lineHeight: '20px',
    fontSize: theme.constants.fontSizes.small,
    wordWrap: 'break-word',
    maxWidth: '8%',
    minWidth: '8%',
    textAlign: 'center',
  },
  activeLabel: {
    lineHeight: '20px',
    fontWeight: 'bold',
    fontSize: theme.constants.fontSizes.small,
    wordWrap: 'break-word',
    maxWidth: '8%',
    minWidth: '8%',
    textAlign: 'center',
  },
});

export default styles;
